export const environment = {
  API_URL: import.meta.env.VITE_APP_API_URL || window.ENV?.VITE_APP_API_URL,
  STRIPE_PUBLIC_KEY:
    import.meta.env.VITE_APP_STRIPE_PUBLIC_KEY || window.ENV?.VITE_APP_STRIPE_PUBLIC_KEY,
  DEVELOPER_PLAN_PRICE_ID:
    import.meta.env.VITE_APP_DEVELOPER_PLAN_PRICE_ID ||
    window.ENV?.VITE_APP_DEVELOPER_PLAN_PRICE_ID,
  ENTERPRISE_PLAN_PRICE_ID:
    import.meta.env.VITE_APP_ENTERPRISE_PLAN_PRICE_ID ||
    window.ENV?.VITE_APP_ENTERPRISE_PLAN_PRICE_ID,
  TEAM_PLAN_PRICE_ID:
    import.meta.env.VITE_APP_TEAM_PLAN_PRICE_ID || window.ENV?.VITE_APP_TEAM_PLAN_PRICE_ID,
  STORAGE_URL: import.meta.env.VITE_APP_STORAGE_URL || window.ENV?.VITE_APP_STORAGE_URL,
  AUTH0_DOMAIN: import.meta.env.VITE_APP_AUTH0_DOMAIN || window.ENV?.VITE_APP_AUTH0_DOMAIN,
  AUTH0_CLIENT_ID: import.meta.env.VITE_APP_AUTH0_CLIENT_ID || window.ENV?.VITE_APP_AUTH0_CLIENT_ID,
  PDC_URL: import.meta.env.VITE_APP_PDC_URL || window.ENV?.VITE_APP_PDC_URL,
  API_PORTAL_URL: import.meta.env.VITE_APP_API_PORTAL_URL || window.ENV?.VITE_APP_API_PORTAL_URL,
  ROWND_APP_KEY: import.meta.env.VITE_APP_ROWND_APP_KEY || window.ENV?.VITE_APP_ROWND_APP_KEY,
  ROWND_API_URL: import.meta.env.VITE_APP_ROWND_API_URL || window.ENV?.VITE_APP_ROWND_API_URL,
  ROWND_ROOT_ORIGIN:
    import.meta.env.VITE_APP_ROWND_ROOT_ORIGIN || window.ENV?.VITE_APP_ROWND_ROOT_ORIGIN,
  ROWND_HUB_BASE_URL:
    import.meta.env.VITE_APP_ROWND_HUB_BASE_URL || window.ENV?.VITE_APP_ROWND_HUB_BASE_URL,
  DEPLOYMENT_ENVIRONMENT:
    import.meta.env.VITE_APP_DEPLOYMENT_ENVIRONMENT || window.ENV?.VITE_APP_DEPLOYMENT_ENVIRONMENT,
  INTEGRATIONS_PRIVATE: import.meta.env.VITE_APP_INTEGRATIONS_PRIVATE
    ? import.meta.env.VITE_APP_INTEGRATIONS_PRIVATE.split(',')
    : [],
  ROWND_WEB_SOCKET_MANAGER_URL:
    import.meta.env.VITE_APP_ROWND_WEB_SOCKET_MANAGER_URL ||
    window?.ENV?.VITE_APP_ROWND_WEB_SOCKET_MANAGER_URL,
  STATUS_URL: import.meta.env.VITE_APP_ROWND_STATUS_URL || window?.ENV?.VITE_APP_ROWND_STATUS_URL || 'https://rownd.instatus.com',
  ROWND_MAGIC_LINK_URL:
    import.meta.env.VITE_APP_ROWND_MAGIC_LINK_URL || window?.ENV?.VITE_APP_ROWND_MAGIC_LINK_URL,
  ROWND_AUTH_URL:
    import.meta.env.VITE_APP_ROWND_AUTH_URL || window?.ENV?.VITE_APP_ROWND_AUTH_URL || 'https://auth.dev.rownd.io',
  ROWND_CHAT_AGENT_URL:
    import.meta.env.VITE_APP_ROWND_CHAT_AGENT_URL || window?.ENV?.VITE_APP_ROWND_CHAT_AGENT_URL || 'https://chat-agent.dev.rownd.io',
};

export const isBespinEnv = environment.DEPLOYMENT_ENVIRONMENT === 'bespin';
